export const download = (data: Blob, fileName: string) => {
  const tempLink = document.createElement('a')

  tempLink.download = fileName
  tempLink.href = window.URL.createObjectURL(data)
  tempLink.style.display = 'none'

  document.body.appendChild(tempLink)
  tempLink.click()
  document.body.removeChild(tempLink)
}

export const downloadCSV = (data: string | string[], fileName: string) => {
  if (Array.isArray(data)) data = data.join('\n')
  const csvFile = new Blob([data], { type: 'text/csv' })
  return download(csvFile, `${fileName}.csv`)
}

export const downloadTxt = (data: string, fileName: string) => {
  const txtFile = new Blob([data], { type: 'text/plain' })
  return download(txtFile, `${fileName}.txt`)
}
